// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"274f9996","75":"a10a63b0","101":"96f71cd8","237":"4548e451","473":"36600c1a","488":"089fbfce","492":"96beea95","575":"9c26c28f","612":"29db145a","996":"74db0e2b"}[chunkId] + ".chunk.js";
};